import { gql } from 'graphql-request';

import {
  CurrencyRateBaseCurrency,
  CurrencyRateData,
  CurrencyRateID,
  CurrencyRatesSource
} from '../currencyRatesTypes';
import { DateType } from '../../../types';

export interface FetchCacheLastDefaultCurrencyRateQueryResponse {
  id: CurrencyRateID;
  baseCurrency: CurrencyRateBaseCurrency;
  data: CurrencyRateData;
  createdAt: DateType;
  source: CurrencyRatesSource;
}

export const FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY = gql`
  query FetchCacheLastDefaultCurrencyRate {
    lastDefaultCurrencyRate {
      id
      baseCurrency
      createdAt
      data
      source
    }
  }
`;
